import { render, staticRenderFns } from "./AddShapeDrawer.vue?vue&type=template&id=1df2d891&scoped=true&"
import script from "./AddShapeDrawer.vue?vue&type=script&lang=js&"
export * from "./AddShapeDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AddShapeDrawer.vue?vue&type=style&index=0&id=1df2d891&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df2d891",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VList,VListItem,VListItemIcon,VNavigationDrawer,VTooltip})
